<template>
  <main class="admin-page">
    <header class="page-heading"><div><div class="page-kicker">PROJECT ORDERS</div><h1 class="page-title">项目订单</h1><p class="page-lead">集中查看项目进度、付款、托管和婚影师结算状态。</p></div><el-button icon="el-icon-refresh" @click="load">刷新</el-button></header>
    <section class="surface"><el-table :data="list" empty-text="暂无项目订单">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="order_no" label="订单号" width="180" />
      <el-table-column prop="title" label="需求标题" />
      <el-table-column prop="amount" label="金额" width="110" />
      <el-table-column prop="status" label="订单状态" width="130" />
      <el-table-column prop="pay_status" label="支付状态" width="110" />
      <el-table-column prop="escrow_status" label="托管状态" width="130" />
      <el-table-column prop="platform_commission" label="平台佣金" width="110" />
      <el-table-column prop="creator_income" label="创作者收入" width="120" />
    </el-table></section>
  </main>
</template>

<script>
import request from '../api/request'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'

export default {
  components: { ElTable, ElTableColumn },
  data() {
    return { list: [] }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      const res = await request.get('/orders')
      this.list = res.list
    }
  }
}
</script>
